import { useEffect, useState } from 'react';
import { api } from '../api/client';

const LEGAL_FORMS = ['Association', 'Entreprise individuelle', 'SARL', 'SA', 'Établissement public', 'Autre'];

function d(v) { return v ? String(v).slice(0, 10) : ''; }

export default function Establishment() {
  const [f, setF] = useState(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get('/school').then((s) => setF({
      ...s,
      creationDate: d(s.creationDate),
      dgMandateStart: d(s.dgMandateStart), dgMandateEnd: d(s.dgMandateEnd),
      principalMandateStart: d(s.principalMandateStart), principalMandateEnd: d(s.principalMandateEnd),
      adminMandateStart: d(s.adminMandateStart), adminMandateEnd: d(s.adminMandateEnd),
    })).catch((e) => setError(e.message));
  }, []);

  if (!f) return <div className="panel"><div className="panel-body"><div className="empty">Chargement…</div></div></div>;

  const set = (k) => (e) => { setF({ ...f, [k]: e.target.value }); setSaved(false); };

  async function save(e) {
    e.preventDefault(); setError(''); setSaving(true);
    const payload = {};
    [
      'name', 'code', 'creationDate', 'approvalRefs', 'legalForm', 'rccm', 'receiptNumber', 'ifu', 'promoter', 'director',
      'dgLastName', 'dgFirstName', 'dgMandateStart', 'dgMandateEnd', 'dgMandateDuration',
      'principalLastName', 'principalFirstName', 'principalMandateStart', 'principalMandateEnd', 'principalMandateDuration',
      'adminLastName', 'adminFirstName', 'adminMandateStart', 'adminMandateEnd', 'adminMandateDuration',
      'boardMembers', 'leaderMandates', 'adminRegion', 'address', 'phone', 'email', 'notes',
    ].forEach((k) => { payload[k] = f[k] === '' ? undefined : f[k]; });
    try { await api.patch('/school', payload); setSaved(true); }
    catch (err) { setError(err.message); }
    finally { setSaving(false); }
  }

  const mandate = (prefix, title) => (
    <>
      <div className="fieldset-title">{title}</div>
      <div className="grid-3">
        <div className="field"><label>Nom</label><input value={f[`${prefix}LastName`] || ''} onChange={set(`${prefix}LastName`)} /></div>
        <div className="field"><label>Prénom</label><input value={f[`${prefix}FirstName`] || ''} onChange={set(`${prefix}FirstName`)} /></div>
        <div className="field"><label>Durée du mandat</label><input value={f[`${prefix}MandateDuration`] || ''} onChange={set(`${prefix}MandateDuration`)} placeholder="ex. 3 ans" /></div>
        <div className="field"><label>Début du mandat</label><input type="date" value={f[`${prefix}MandateStart`] || ''} onChange={set(`${prefix}MandateStart`)} /></div>
        <div className="field"><label>Fin du mandat</label><input type="date" value={f[`${prefix}MandateEnd`] || ''} onChange={set(`${prefix}MandateEnd`)} /></div>
      </div>
    </>
  );

  return (
    <div className="panel">
      <div className="panel-head">
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <img src="/logo-ioba.png" alt="Schoolizy Ioba" style={{ height: 40, width: 'auto' }} />
          <h2 style={{ margin: 0 }}>Fiche établissement</h2>
        </div>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          {saved && <span className="badge green">Enregistré ✓</span>}
          <button className="btn btn-sm" onClick={save} disabled={saving}>{saving ? 'Enregistrement…' : 'Enregistrer'}</button>
        </div>
      </div>
      <div className="panel-body" style={{ padding: 18 }}>
        {error && <div className="form-error">{error}</div>}
        <form onSubmit={save}>
          <div className="fieldset-title">Identité</div>
          <div className="grid-3">
            <div className="field" style={{ gridColumn: 'span 2' }}><label>Nom de l'établissement *</label><input value={f.name || ''} onChange={set('name')} required /></div>
            <div className="field"><label>Code établissement</label><input value={f.code || ''} onChange={set('code')} /></div>
            <div className="field"><label>Date de création</label><input type="date" value={f.creationDate || ''} onChange={set('creationDate')} /></div>
            <div className="field"><label>Promoteur</label><input value={f.promoter || ''} onChange={set('promoter')} /></div>
            <div className="field"><label>Directeur</label><input value={f.director || ''} onChange={set('director')} /></div>
          </div>

          <div className="fieldset-title">Statut juridique & agréments</div>
          <div className="grid-3">
            <div className="field"><label>Forme juridique</label>
              <select value={f.legalForm || ''} onChange={set('legalForm')}>
                <option value="">—</option>{LEGAL_FORMS.map((x) => <option key={x} value={x}>{x}</option>)}
              </select></div>
            <div className="field"><label>Registre de commerce (RCCM)</label><input value={f.rccm || ''} onChange={set('rccm')} /></div>
            <div className="field"><label>Récépissé</label><input value={f.receiptNumber || ''} onChange={set('receiptNumber')} /></div>
            <div className="field"><label>IFU</label><input value={f.ifu || ''} onChange={set('ifu')} /></div>
            <div className="field" style={{ gridColumn: 'span 2' }}><label>Références agréments & autorisations</label><textarea rows="2" value={f.approvalRefs || ''} onChange={set('approvalRefs')} /></div>
          </div>

          <div className="fieldset-title" style={{ color: 'var(--navy)', borderColor: 'var(--gold)' }}>Gouvernance & mandats</div>
          {mandate('dg', 'Directeur Général')}
          {mandate('principal', 'Proviseur / Directeur')}
          {mandate('admin', 'Administrateur')}
          <div className="grid-3">
            <div className="field" style={{ gridColumn: 'span 3' }}><label>Conseil d'administration (membres)</label><textarea rows="2" value={f.boardMembers || ''} onChange={set('boardMembers')} /></div>
            <div className="field" style={{ gridColumn: 'span 3' }}><label>Mandats des dirigeants</label><textarea rows="2" value={f.leaderMandates || ''} onChange={set('leaderMandates')} /></div>
          </div>

          <div className="fieldset-title">Coordonnées</div>
          <div className="grid-3">
            <div className="field"><label>Province / Région</label><input value={f.adminRegion || ''} onChange={set('adminRegion')} /></div>
            <div className="field"><label>Téléphone</label><input value={f.phone || ''} onChange={set('phone')} /></div>
            <div className="field"><label>E-mail</label><input value={f.email || ''} onChange={set('email')} /></div>
            <div className="field" style={{ gridColumn: 'span 3' }}><label>Adresse</label><textarea rows="2" value={f.address || ''} onChange={set('address')} /></div>
            <div className="field" style={{ gridColumn: 'span 3' }}><label>Notes administratives</label><textarea rows="2" value={f.notes || ''} onChange={set('notes')} /></div>
          </div>

          <div style={{ marginTop: 18 }}>
            <button className="btn" type="submit" disabled={saving} style={{ width: 'auto', padding: '0 24px' }}>{saving ? 'Enregistrement…' : 'Enregistrer la fiche'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
